import Text from '@/components/Text';
import { TextComponentType } from '@/types/atoms';

type ListCardProps = {
  number: number;
  textComponent: TextComponentType;
};

const ListCard = ({ number, textComponent }: ListCardProps) => (
  <li className="grid-base gap-2 py-4 max-md:pb-10 border-t">
    <div className="text-huge md:col-span-2">{number ?? 1}</div>
    {textComponent && (
      <Text
        layout={1}
        className="col-start-3 lg:col-start-9 col-span-4 md:col-span-4 flex flex-col md:pr-6 pb-[120px]"
        textComponent={textComponent}
      />
    )}
  </li>
);

export default ListCard;
